import React from 'react'
import '../Css/header-footer.css'
import { NavLink } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {

    const { t } = useTranslation();
    const { lang } = useLanguage();

    return (
        <footer dir={lang === "ar" ? "rtl" : "ltr"}>
            <div className="footer-container">

                <div className="footer-row">

                    {/* Column 1 */}
                    <div className="footer-col">
                        <h5 className="footer-title">{t("footer_title")}</h5>
                        <p className="footer-dec">{t("footer_text")}</p>
                    </div>

                    {/* Column 2 */}
                    <div className="footer-col">
                        <h5 className="footer-title">{t("footer_quick_links")}</h5>

                        <ul className="footer-list">
                            <li><NavLink to="/">{t("home")}</NavLink></li>
                            <li><NavLink to="/about">{t("about")}</NavLink></li>
                            <li><NavLink to="/services">{t("services")}</NavLink></li>
                            <li><NavLink to="/stories">{t("stories")}</NavLink></li>
                            <li><NavLink to="/term">{t("term")}</NavLink></li>
                            <li><NavLink to="/contact-us">{t("contact")}</NavLink></li>
                        </ul>
                    </div>

                    {/* Column 3 */}
                    <div className="footer-col">
                        <h5 className="footer-title">{t("footer_contact")}</h5>

                        <ul className="footer-list">
                            <li>
                                <span className="footer-label">{t("contact_email")}: </span>
                                info@aetheris.ae
                            </li>

                            <li>
                                <span className="footer-label">{t("contact_phone")}:</span>
                                <span className="ltr-number"> +971 50 866 8443</span>
                            </li>

                            <li>
                                <span className="footer-label">{t("footer_location")}:</span>
                                {t("footer_location_data")} <br /> {t("footer_location_data2")}
                            </li>
                        </ul>
                    </div>
                </div>

                <hr className="footer-line" />

                <div className="footer-bottom">
                    <p>© 2025 Aetheris AI Solutions – All Rights Reserved</p>

                    <small className="powered">
                        Powered By:
                        <a href="https://unifi-me.com" target="_blank" rel="noreferrer"> VIA UNiFi Information Technology </a>
                    </small>
                </div>

            </div>
        </footer>
    )
}

export default Footer
